// DS: C33A
/** Bottom section of a thumb, containing related information */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Flex from '@wix/da-ds/pkg/Flex';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import DeviationLink from '../Duperbrowse/DeviationLink';
import Button from '../Button';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './ThumbInfo.scss';
var AVATAR_SIZE_DESKTOP = 32;
var AVATAR_SIZE_MOBILE = 24;
var ThumbInfo = function (_a) {
    var user = _a.user, title = _a.title, urlDeviation = _a.urlDeviation;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var kill_prints_act_two = useFlag('kill_prints_act_two');
    var showBuyPrintButton = !!urlDeviation.printId && !kill_prints_act_two;
    return (React.createElement("div", { className: classnames(s['root'], title ? s['with-title'] : s['without-title']) },
        (!title || !isMobile) && (React.createElement(UserAvatar, { size: isMobile ? AVATAR_SIZE_MOBILE : AVATAR_SIZE_DESKTOP, user: user, className: s['avatar'] })),
        !title && (React.createElement(UserLink, { user: user, className: s['username'], biData: {
                creatorid: user.useridUuid,
            } })),
        title && (React.createElement("div", { className: s['info'] },
            React.createElement(DeviationLink, { className: s['title'], deviation: urlDeviation }, title),
            React.createElement(Flex, { className: s['secondRow'], alignItems: "center" },
                isMobile && (React.createElement(UserAvatar, { size: AVATAR_SIZE_MOBILE, user: user, className: s['avatar'] })),
                React.createElement(UserLink, { user: user, className: s['username'], biData: {
                        creatorid: user.useridUuid,
                    } })))),
        showBuyPrintButton && (React.createElement("div", { className: s['print-buy'] },
            React.createElement(Button, { view: "b18", height: "small", href: Url.printLink(urlDeviation.deviationId) }, t('common.buy'))))));
};
ThumbInfo.displayName = 'ThumbInfo';
export default ThumbInfo;
//# sourceMappingURL=ThumbInfo.js.map